<template>
<div class="color_indicator_2">
    <input type="color" v-model="color"  @blur="onBlur"  class="color_indicator_2"/>
</div>
</template>


<script>
export default {
    name: 'PickLegendColor',
    props: {
        col: String,
        index: Number
    },
    methods: {
        rgb2hex(rgb){
            rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)
            return (rgb && rgb.length === 4) ? "#" +
            ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : ''
        },
        hexToRgbA(hex){
            var c;
            if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                c= hex.substring(1).split('');
                if(c.length== 3){
                    c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c= '0x'+c.join('');
                return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)';
            }
            throw new Error('Bad Hex');
        },
        onBlur() {
            //console.log(c)
            console.log('*** OnBlur ***')
            //console.log(this.$store.getters.legendColors)
            let legCols = this.$store.getters.legendColors
            let newLegendCols = []
            for (let l of legCols) {
                newLegendCols.push(l)
            }
            newLegendCols[this.index] = this.hexToRgbA(this.color)
            this.$store.commit('setLegendColors', newLegendCols)
            // this.$root.$emit('component_refresh')
        }   
    },
    watch: {
        /*
        color: function (c) {
            // console.log(c)
            // console.log(this.index)
            // this.onBlur(c)
        }
        */
    },
    data () {
        return {
            color: '#a6c510'
        }    
    },
    mounted () {
        // const rgbHex = require('rgb-hex')
        if (this.col.indexOf("#") >= 0) {
            this.color = this.col
        } else {
            this.color = this.rgb2hex(this.col) 
        }
    }
}

</script>

<style>
.color_indicator_2 {
  height: 23px;
  width: 20px;
  float:left; display:block;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 0px;
}

</style>


